import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/pages/Home';
import Maker from './components/pages/Maker';
import Manager from './components/pages/Manager';
import Master from './components/pages/Master';
import EcosystemPage from './components/pages/Ecosystem';
import InitiativeFourEcosystem from './components/pages/Initiatives/Ecosystem';
import AboutPictureOfSuccess from './components/pages/About/PictureOfSuccess';
import AboutHowItWorks from './components/pages/About/HowItWorks';
import AboutHowToGetInvolved from './components/pages/About/HowToGetInvolved';
import InitiativesAiLiteracyUplift from './components/pages/Initiatives/AILiteracyUpliftMod';
import InitiativesBuildPlatform from './components/pages/Initiatives/BuildPlatform';
import InitiativesCompanionIncubator from './components/pages/Initiatives/AILabIncubator';
import InitiativeOne from './components/pages/Initiatives/InitiativeOne';
import InitiativeTwo from './components/pages/Initiatives/InitiativeTwo';
import InitiativeThree from './components/pages/Initiatives/InitiativeThree';
import Initiatives from './components/pages/Initiatives';
import AIToolsDirectory from './components/pages/AIToolsDirectory';
import AIPolicies from './components/pages/AIPolicies';
import About from './components/pages/About/About';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/initiatives" element={<Initiatives />} />
          <Route path="/initiative-one/ai-literacy-uplift-and-alignment" element={<InitiativeOne />} />
          <Route path="/initiative-two/build-platform" element={<InitiativeTwo />} />
          <Route path="/initiative-three/companion-incubator" element={<InitiativeThree />} />
          <Route path="/initiatives/ecosystem" element={<InitiativeFourEcosystem />} />
          <Route path="/initiative-one/ai-literacy-uplift-and-alignment/maker" element={<Maker />} />
          <Route path="/initiative-one/ai-literacy-uplift-and-alignment/manager" element={<Manager />} />
          <Route path="/initiative-one/ai-literacy-uplift-and-alignment/master" element={<Master />} />
          <Route path="/ecosystem" element={<EcosystemPage />} />
          <Route path="/about/picture-of-success" element={<AboutPictureOfSuccess />} />
          <Route path="/about/how-it-works" element={<AboutHowItWorks />} />
          <Route path="/about/how-to-get-involved" element={<AboutHowToGetInvolved />} />
          <Route path="/initiatives/ai-literacy-uplift" element={<InitiativesAiLiteracyUplift />} />
          <Route path="/initiatives/build-platform" element={<InitiativesBuildPlatform />} />
          <Route path="/initiatives/companion-incubator" element={<InitiativesCompanionIncubator />} />
          <Route path="/ai-tools" element={<AIToolsDirectory />} />
          <Route path="/ai-policies" element={<AIPolicies />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
